<template>
    <div v-loading="dataLoading">
        <div class="group">
            <div class="page-group-title"><span>销售汇总</span></div>
            <el-card v-if="data" shadow="never" class="MT20">
                <el-row :gutter="40">
                    <el-col><span class="color-info">演出ID: </span>{{data.id}}</el-col>
                    <el-col><span class="color-info">演出名称: </span>{{data.title}}</el-col>
                    <el-col><span class="color-info">销售票数: </span>{{data.saleTicketNum}}</el-col>
                    <el-col><span class="color-info">销售金额: </span>{{data.saleAmountFormat}}</el-col>
                    <el-col>
						<span class="color-info">优惠: </span>
						<!-- {{data.platDiscountFormat}} -->
						<span>秀动承担优惠：{{data.platDiscountFormat}}</span>
						<span class="ML20">B类承担优惠：{{data.busDiscountFormat}}</span>
						<span class="ML20">乐迷服务费：（帮抢服务费：{{data.helpServiceFeeFormat}}、候补服务费：{{data.alternateServiceFeeFormat}}）</span>
					</el-col>
                    <el-col><span class="color-info">实际收入: </span><span class="color-danger">{{data.amountFormat}}</span></el-col>
                </el-row>
            </el-card>
        </div>
        <div v-if="data && data.payPlatforms" class="group MT20">
            <div class="page-group-title"><span>支付平台</span></div>
            <el-card shadow="never" class="MT20">
                <el-row :gutter="40" type="flex" align="middle">
                    <el-col :xs="24" :sm="12">
                        <div v-for="(item,index) in data.payPlatforms" :key="index">
                            <span class="color-info">{{item.name}}收入: </span>{{item.payAmountFormat}} 
                            <span class="color-info">占比: </span>{{item.payAmountRate}}%
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <div id="chartContainer1" ref="chartContainer1"></div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div v-if="data && data.partners" class="group MT20">
            <div class="page-group-title"><span>外部售票渠道</span></div>
            <el-card shadow="never" class="MT20">
                <el-row :gutter="40" type="flex" align="middle">
                    <el-col :xs="24" :sm="12">
                        <div v-for="(item,index) in data.partners" :key="index">
                            <span class="color-info">{{item.name}}收入: </span>{{item.payAmountFormat}} 
                            <span class="color-info">占比: </span>{{item.payAmountRate}}%
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <div id="chartContainer2" ref="chartContainer2"></div>
                    </el-col>
                </el-row>
            </el-card>
            <!-- <table class="info-table MT20" width="100%">
                <tr v-for="(item,index) in data.partners" :key="index">
                    <th>{{item.name}}收入</th>
                    <td>{{item.payAmountFormat}}</td>
                    <th>{{item.name}}收入占比</th>
                    <td>{{item.payAmountRate}}%</td>
                </tr>
            </table> -->
        </div>
        <div class="group MT20">
            <div class="page-group-title"><span>通票</span></div>
            <el-table
                v-if="data"
                :data="data.throughTickets"
                border
                style="width: 100%"
                size="small"
                stripe
                class="MT20"
            >
                <el-table-column prop="ticketName" label="名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="ticketPrice" label="最新单价"></el-table-column>
                <el-table-column prop="ticketNum" label="售票数"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                <el-table-column prop="ticketNumActivityRate" label="票数演出占比">
                    <template slot-scope="scope">
                        {{scope.row.ticketNumActivityRate}}%
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmountActivityRate" label="金额演出占比">
                    <template slot-scope="scope">
                        {{scope.row.saleAmountActivityRate}}%
                    </template>
                </el-table-column>
				<el-table-column prop="refundFeeStr" label="扣除乐迷手续费"></el-table-column>
				<el-table-column prop="xdRetainRefundFeeStr" label="秀动保留手续费" min-width="120"></el-table-column>
				<el-table-column prop="settleRefundFeeStr" label="结给主办手续费" min-width="120"></el-table-column>
            </el-table>
        </div>
        <div class="group MT20">
            <div class="page-group-title"><span>场次售票</span></div>
            <el-table
                v-if="data"
                :data="data.tickets"
                border
                style="width: 100%"
                size="small"
                stripe
                class="MT20"
            >
                <el-table-column prop="sessionName" label="场次" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ticketName" label="票品"></el-table-column>
				<el-table-column prop="ticketPrice" label="最新单价"></el-table-column>
                <el-table-column prop="ticketNum" label="销售票数"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                <el-table-column prop="ticketNumSessionRate" label="票数场次占比">
                    <template slot-scope="scope">
                        {{scope.row.ticketNumSessionRate}}%
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmountSessionRate" label="金额场次占比">
                    <template slot-scope="scope">
                        {{scope.row.saleAmountSessionRate}}%
                    </template>
                </el-table-column>
                <el-table-column prop="ticketNumActivityRate" label="票数演出占比">
                    <template slot-scope="scope">
                        {{scope.row.ticketNumActivityRate}}%
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmountActivityRate" label="金额演出占比">
                    <template slot-scope="scope">
                        {{scope.row.saleAmountActivityRate}}%
                    </template>
                </el-table-column>
				<el-table-column prop="refundFeeStr" label="扣除乐迷手续费"></el-table-column>
				<el-table-column prop="xdRetainRefundFeeStr" label="秀动保留手续费" min-width="120"></el-table-column>
				<el-table-column prop="settleRefundFeeStr" label="结给主办手续费" min-width="120"></el-table-column>
            </el-table>
        </div>
        <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
        </div>
    </div>
</template>
<script>
import { Chart } from '@antv/g2';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/finance/activity/settlement/list',
            data:null
        }
    },
    mounted(){
        this.getDataDetail();
    },
    methods:{
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/activityFinanceSettle/info",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.$nextTick(() => {
                            if(this.$refs.chartContainer1) this.drawChart('chartContainer1',this.data.payPlatforms);
                            if(this.$refs.chartContainer2) this.drawChart('chartContainer2',this.data.partners);
                        })
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //绘制图表
        drawChart(id,data){
                const _data = JSON.parse(JSON.stringify(data)), _id = id;
                
                const chart = new Chart({
                    container: _id,
                    autoFit: true,
                    height: 250,
                });
                _data.map((v) => {
                    v.payAmountFormat = parseFloat(v.payAmountFormat);
                })
                chart.data(_data);
                chart.coordinate('theta', {
                    radius: 0.75
                });

                chart.tooltip({
                    showMarkers: false,
                    showTitle: false,
                });
                chart.legend({
                    position: 'right',
                });

                chart
                    .interval()
                    .adjust('stack')
                    .position('payAmountFormat')
                    .color('name')
                    .label('name', (val) => {
                        return {
                            content: (obj) => {
                                return obj.name + '\n收入占比' +  obj.payAmountRate + '%';
                            },
                        };
                    });

                chart.interaction('element-single-selected');

                chart.render();
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
        span{
            vertical-align: top;
        }
    }
}

</style>